import styled from 'styled-components';

export const Container = styled.div`
  max-width: 75%;
  width: max-content;

  .message-date {
    font-size: 12px;
    font-weight: 500;
    color: #202020;
  }

  &.bg-me {
    border-radius: 16px;
    border-bottom-right-radius: 0px;
    background: #ffeee3;
  }

  &.bg {
    border-radius: 16px;
    border-bottom-left-radius: 0px;
    background: #f0f0f0;
  }

  .markdown-body {
    p {
      color: #5a5a5a;
      font-family: 'Poppins';
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 0;
      white-space: pre-line;
    }

    strong {
      color: #333;
    }

    ul,
    ol {
      color: #5a5a5a;
      font-size: 14px;
      padding-left: 20px;
    }
  }
`;
